import { gql } from '@apollo/client';

export const GET_CSV = gql`query GetPaypalCsv($input: PaypalCsvInput) {
    getPaypalCsv(input: $input) {
      csv
    }
  }
`;
